<template>
  <div class="call_out_plan" :style="screenHeight">
    <Tabs value="ipBlacklist" @on-click="changeTab" style="height: 100%;border-bottom: 1px solid rgb(235, 238, 245);" >
      <TabPane label="IP黑名单" name="ipBlacklist">
        <div class="fixed_search">
          <div class="fixed_search_input">
            <Input v-model="ipAddress" placeholder="IP地址" title="IP地址" clearable/>
          </div>
          <div class="date_input fixed_search_input">
            <el-date-picker v-model="createTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始操作时间" end-placeholder="结束操作时间"
                            align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
          <div class="fixed_operation_btn" style="width: auto">
            <Button type="primary" @click="initSearch">查询</Button>
            <Button type="primary" class="operation_btn reset_btn" @click="resetIP">重置</Button>
          </div>
        </div>
        <div class="public_btn">
            <Button v-if="roleList['3_12-2-1']" class="search_btn template_btn"  @click="addIp">添加</Button>
            <Button v-if="roleList['3_12-2-2']" class="search_btn template_btn"  @click="importIp">导入</Button>
            <Button v-if="roleList['3_12-2-3']" class="search_btn template_btn"  @click="exportIp">导出</Button>
            <Button v-if="roleList['3_12-2-4']" class="search_btn template_btn"   @click="batchdeletIp">批量删除</Button>
        </div>
        <div class="fixed_table">
                <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
                  <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                  <el-table-column  fixed="right" label="操作"   align="center">
                    <template slot-scope="scope">
                      <el-button v-if="roleList['3_12-2-5']" @click="editip(scope.row.id,scope.row.blackType)"  type="text" size="small">编辑</el-button>
                      <el-button v-if="roleList['3_12-2-6']" @click="deleteip(scope.row.id,scope.row.blackType)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
        </div>
      </TabPane>
      <TabPane label="访客黑名单" name="visitorBlacklist">
        <div class="fixed_search">
          <div class="fixed_search_input">
            <Input v-model="visitorName" placeholder="访客名称" title="访客名称" clearable/>
          </div>
          <div class="fixed_search_input">
            <Input v-model="ipOpenid" placeholder="访客openid" title="访客openid" clearable/>
          </div>
          <div class="date_input fixed_search_input">
            <el-date-picker v-model="viscreateTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始操作时间" end-placeholder="结束操作时间"
                            align="left" :default-time="['00:00:00', '23:59:59']"  :editable="editable" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </div>
          <div class="fixed_operation_btn" style="width: auto">
            <Button type="primary" @click="initSearch">查询</Button>
            <Button type="primary" class="operation_btn reset_btn" @click="resetVis">重置</Button>
          </div>
        </div>
        <div class="public_btn">
            <Button v-if="roleList['3_12-2-1']" class="search_btn template_btn" @click="addIp">添加</Button>
            <Button v-if="roleList['3_12-2-2']" class="search_btn template_btn"  @click="importIp">导入</Button>
            <Button v-if="roleList['3_12-2-3']" class="search_btn template_btn"  @click="exportIp">导出</Button>
            <Button v-if="roleList['3_12-2-4']" class="search_btn template_btn"   @click="batchdeletIp">批量删除</Button>
        </div>
        <div class="fixed_table">
                <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
                <el-table :data="contentList" style="width: 100%" :height="tableHeight"  class="element_table" :class="{'tableClass':tableClass}" stripe  ref="selection"  @selection-change="getSelectedId">
                  <el-table-column v-for="(item,index) in visfieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index"  :prop="item.key" :label="item.title" :width="item.width"></el-table-column>
                  <el-table-column  fixed="right" label="操作"   align="center">
                    <template slot-scope="scope">
                      <el-button v-if="roleList['3_12-2-5']" @click="editip(scope.row.id,scope.row.blackType)"  type="text" size="small">编辑</el-button>
                      <el-button v-if="roleList['3_12-2-6']" @click="deleteip(scope.row.id,scope.row.blackType)" type="text" size="small">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
        </div>
      </TabPane>
    </Tabs>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
    <AddipPop @closeAddipPop="closeAddipPop" :showAddipPop="showAddipPop" :ipId="ipId" :btype="btype"></AddipPop>
    <ImportipPop @closeImportipPop="closeImportipPop" :showImportipPop="showImportipPop" :iplisttype="iplisttype"></ImportipPop>
    <ExportipPop @closeExportipPop="closeExportipPop" :showExportipPop="showExportipPop" :iplisttype="iplisttype"></ExportipPop>
    <DelectionipPop @closedelecPop="closedelecPop" :showdelecPop="showdelecPop" :iplisttype="iplisttype"></DelectionipPop>
  </div>
</template>

<script>
    import {publicFunClass} from '@/components/js/PublicFunClass.js'
    import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    import AddipPop from '@/components/systemSetup/DialogueConfigure/AddipPop.vue'
    import ImportipPop from '@/components/systemSetup/DialogueConfigure/ImportipPop.vue'
    import ExportipPop from '@/components/systemSetup/DialogueConfigure/ExportipPop.vue'
    import DelectionipPop from '@/components/systemSetup/DialogueConfigure/DelectionipPop.vue'
    export default {
        name: "Blacklist",
        mixins:[publicFunClass,customerPublicBtn],
        components:{
          AddipPop,
          ImportipPop,
          ExportipPop,
          DelectionipPop
        },
        props:{
          pageCode:String
        },
        data(){
          return {
            screenHeight:{height:''},
            showPageCount:0,
            //spinShow:true,
            spinShow:false,
            tabsName:'',
            editable:false,
            tableClass: true,
            tableHeight:600,
            roleList: JSON.parse(localStorage.getItem("roleList")),
            total: 0,
            pageSizeList: [10, 20, 30, 40, 50, 100, 200],
            speedChangePage: 1,
            currentPage: 1,
            pageSize: 20,
           // contentList: [{"IPadress":"192.168.09.31","blockreason":"欠费","remarks":"","optime":"2020-12-08"},{"IPadress":"192.168.09.111","blockreason":"","remarks":"","optime":"2020-11-23"}],
            contentList: [],
            fieldList: [
                {type: 'selection', width: 50},
                {key:'blackList','title':'IP地址'},
                {key:'blackReason','title':'拉黑原因'},
                {key:'descr','title':'备注'},
                {key:'createTime','title':'操作时间'},
              ],
            visfieldList:[
                {type: 'selection', width: 50},

                {key:'visitorName','title':'访客名称'},
                {key:'blackList','title':'访客openid'},
                {key:'agentNo','title':'操作员工'},
                {key:'blackReason','title':'拉黑原因'},
                {key:'descr','title':'备注'},
                {key:'createTime','title':'操作时间'},
            ],
            ipAddress:'',
            ipOpenid:'',
            createTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
            viscreateTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
            checkIds:[],
            ipId:'',
            btype:'',
            visitorName:'',
            showAddipPop:false,
            showImportipPop:false,
            iplisttype:'',
            showExportipPop:false,
            showdelecPop:false,
            queryParam: null,
          }
        },
        methods:{
          changeTab:function(name){
            if(name=="ipBlacklist"){
              this.tabsName="1";
            }
            if(name=="visitorBlacklist"){
              this.tabsName="2";
            }
            // this.ipAddress="";
             this.initSearch();
          },
          resetIP:function(){
              this.ipAddress="";
              this.createTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
          },
          resetVis:function(){
              this.ipOpenid="";
              this.visitorName="";
              this.viscreateTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
          },
          //查询
          initSearch:function () {
             let that=this;
            let param={};
            if(this.tabsName=="1"){//ip
              param={
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                type:"1",
                createTime: this.createTime? (this.createTime.length==0?"":this.createTime.toString()) : "",
                blackList:this.ipAddress,
                journalType: "系统管理=>会话配置=>黑名单=>查询",
                menuId: "3_12-2",
              };
                this.spinShow=true;
                this.queryParam = param;
                this.$http.post("chatBlackList/toIndex.json",param) .then(function (res) {
                  let result=res.data.flag;
                  that.spinShow=false;
                  if(result!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    return false;
                  }
                  that.checkIds=[];
                  that.contentList=res.data.obj.list.content;
                  that.total=res.data.obj.list.totalSize;

                });
            }
            if(this.tabsName=="2"){//访客
              param={
                pageNum:this.currentPage,
                pageSize:this.pageSize,
                type:"2",
                createTime: this.viscreateTime? (this.viscreateTime.length==0?"":this.viscreateTime.toString()) : "",
                blackList:this.ipOpenid,
                visitorName:this.visitorName,
                journalType: "系统管理=>会话配置=>黑名单=>查询",
                menuId: "3_12-2",
              };
              this.spinShow=true;
              this.queryParam = param;

              this.$http.post("chatBlackList/toIndex.json",param) .then(function (res) {
                  let result=res.data.flag;
                  that.spinShow=false;
                  if(result!="666"){
                    that.$Modal.info({
                      title:'提示',
                      content:res.data.msg
                    });
                    return false;
                  }
                  that.checkIds=[];
                  that.contentList=res.data.obj.list.content;
                  that.total=res.data.obj.list.totalSize;

              });

            }
          },
          closeAddipPop:function(flag){
            this.showAddipPop=false;
           if(flag){
              this.initSearch();
            }
          },
          //添加
          addIp:function () {
            this.showAddipPop=true;
            this.ipId='';
            if(this.tabsName=="1"){//ip黑名单
              this.btype='';
            }
            if(this.tabsName=="2"){//访客黑名单
              this.btype='3';
            }
          },
          //编辑
          editip:function (id,type) {
              this.showAddipPop=true;
              this.ipId=id+'';
              this.btype=type+'';
          },
          //删除
          deleteip:function (id,btype) {
            let that=this;
            let param={
                type:"0",//单条删除type为0选中
                ids:id,
                blackType:btype,
                journalType: "系统管理=>会话配置=>黑名单=>删除",
                menuId: "3_12-2-6",
            };
            this.$Modal.confirm({
              title: '提示',
              content: "是否确定删除",
              onOk: () => {
                that.$http.post("chatBlackList/doDeletes.json",param) .then(function (res) {
                  let result=res.data.flag;
                  if(result!="666"){
                    that.$alert(res.data.msg, '提示', {
                      confirmButtonText: '确定'
                    });
                    return false;
                  }
                  that.$Message.info("删除成功");
                  that.initSearch();
                });
              }
            });
          },
          //批量删除
          batchdeletIp:function () {
            if(this.tabsName=="1"){
              this.iplisttype="1";
            }
            if(this.tabsName=="2"){
              this.iplisttype="2";
            }
            this.showdelecPop=true;
          },
          closedelecPop:function(flag,deleteStyle,delettabstype){//后两个参数为: 选择按结果0/按搜索1    ip1/访客2
            this.showdelecPop=false;
            let deletlisttype;
            if(delettabstype=="1"){
                  deletlisttype="1,2"
              }else if(delettabstype=="2"){
                  deletlisttype="3"
            }
            if (flag) {
              let param=[];
              if (deleteStyle=='0'){//选中结果删除
                if (this.checkIds.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                 param={
                  type:deleteStyle,//1搜索 0选中
                  ids:this.checkIds.toString(),
                  journalType: "系统管理=>会话配置=>黑名单=>批量删除",
                  menuId: "3_12-2-4",
                };
              }
              if (deleteStyle=='1'){//搜索结果删除
                if(this.contentList.length==0){
                  this.$Modal.info({
                    title:'提示',
                    content:"当前无可删除的数据"
                  });
                  return false;
                }
                if(!this.queryParam){
                  this.$Modal.info({
                    title:'提示',
                    content:"请点击查询后再删除"
                  });
                  return false;
                }

                 delete this.queryParam["pageNum"];
                  delete this.queryParam["pageSize"];
                   
                  this.$set(this.queryParam, 'blackType', deletlisttype);
                  this.$set(this.queryParam, 'type', deleteStyle);
                  this.$set(this.queryParam, 'journalType', "系统管理=>会话配置=>黑名单=>批量删除");
                  this.$set(this.queryParam, 'menuId', '3_12-2-4');

                  param = this.queryParam;

              }
              let that=this;
              that.$Modal.confirm({
                    title: '提示',
                    content: "是否确定删除",
                    onOk: () => {
                      that.$http.post("chatBlackList/doDeletes.json",param) .then(function (res) {
                        let result = res.data.flag;
                        if(result!="666"){
                          that.$alert(res.data.msg, '提示', {
                            confirmButtonText: '确定'
                          });
                          return false;
                        }
                        that.$Message.info("删除成功");
                        that.initSearch();
                      });
                    }
              });
            }
          },
          //导入
          importIp:function (id) {
            if(this.tabsName=="1"){
              this.iplisttype="1";
            }
            if(this.tabsName=="2"){
              this.iplisttype="2";
            }
             this.showImportipPop=true
          },

          closeImportipPop:function(flag){
            this.showImportipPop=false
            if(flag){
              this.initSearch();
            }
          },
          //导出
          exportIp:function(){
            if(this.tabsName=="1"){
              this.iplisttype="1";
            }
            if(this.tabsName=="2"){
              this.iplisttype="2";
            }
            this.showExportipPop=true;
          },
          closeExportipPop:function (flag,operateStyle,exporttabstype) {
              this.showExportipPop=false;
              let exportlisttype;
              let journalType = "";
              if(exporttabstype=="1"){
                  exportlisttype="1,2"  //ip
                  journalType = "IP";
              }else if(exporttabstype=="2"){
                  exportlisttype="3" //访客
                  journalType = "访客";
              }
              if (flag) {
                if (operateStyle=='0'){//选中结果
                  if (this.checkIds.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"请选择要导出的数据"
                    });
                    return false;
                  }
                  let param={
                    ids:this.checkIds.toString(),
                    type:operateStyle,
                     blackType:exportlisttype,
                     journalType: "系统管理=>会话配置=>黑名单=>按选中结果导出"+journalType+"黑名单",
                     menuId: "3_12-2-3",
                  };
                  let url="chatBlackList/exportChatBlackList.json";
                  this.$Loading.start();
                  this.operateExcelExport(param,url)
                }
                if (operateStyle=='1'){//按搜索结果
                  if(this.contentList.length==0){
                    this.$Modal.info({
                      title:'提示',
                      content:"当前无可导出的数据"
                    });
                    return false;
                  }
                  if(!this.queryParam){
                    this.$Modal.info({
                      title:'提示',
                      content:"请点击查询后再导出"
                    });
                    return false;
                  }
                  if(exporttabstype=="1"){
                    delete this.queryParam["pageNum"];
                    delete this.queryParam["pageSize"];

                    this.$set(this.queryParam, 'type', exporttabstype);
					          this.$set(this.queryParam, 'blackType', exportlisttype);
                    this.$set(this.queryParam, 'journalType', "系统管理=>会话配置=>黑名单=>按搜索结果导出IP黑名单");
                    this.$set(this.queryParam, 'menuId', '3_12-2-3'); 
                  }else if(exporttabstype=="2"){
                    delete this.queryParam["pageNum"];
                    delete this.queryParam["pageSize"];
                    this.$set(this.queryParam, 'blackType', exportlisttype);
                    this.$set(this.queryParam, 'type', exporttabstype);
                    this.$set(this.queryParam, 'journalType', "系统管理=>会话配置=>黑名单=>按搜索结果导出访客黑名单");
                    this.$set(this.queryParam, 'menuId', '3_12-2-3');
                  }
                  
                  let url="chatBlackList/exportChatBlackList.json";
                  this.$Loading.start();
                  this.operateExcelExport(this.queryParam,url)
                }
              }
          },


        },
        created(){
          this.screenHeight.height=this.mountHeight(130);
          let clientHeight=document.documentElement.clientHeight;
          this.tableHeight=clientHeight-200;
          this.tabsName='1';
          this.initSearch();
        },
        watch:{
          pageCode:function () {
            if(this.pageCode=='3_12-2' && this.showPageCount==0){
              // this.showPageCount++;
              // this.initSearch();
            }
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/systemSetup/DialogueConfigure/Blacklist.vue